import React, { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { ImpersonationBanner } from './ImpersonationBanner';
import { Toaster } from '../ui/sonner';

export const Layout = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (mobile) {
        setIsCollapsed(true);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="app-layout tactical-bg">
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <main 
        className="main-content overflow-x-hidden" 
        data-testid="main-content"
        style={{ 
          marginLeft: isMobile ? 0 : (isCollapsed ? '4rem' : '14rem'),
          transition: 'margin-left 0.3s ease-in-out',
          maxWidth: isMobile ? '100vw' : undefined,
          width: isMobile ? '100%' : undefined
        }}
      >
        <ImpersonationBanner />
        {children}
      </main>
      <Toaster position="top-right" />
    </div>
  );
};
